import { render, staticRenderFns } from "./RolesUserBreakdown.vue?vue&type=template&id=285aee00&"
import script from "./RolesUserBreakdown.vue?vue&type=script&lang=js&"
export * from "./RolesUserBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports